const wishlistItem = {
    emits: ['remove'],
    template: `<div class="item">
                <a v-bind:href="product.url" class="product-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></a>
                <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product,'remove')"><i class="fa fa-times" aria-hidden="true"></i></span>
                <a v-bind:href="product.url" class="link-view">View</a>
              </div>`,

    props: {
        product: Object
    },
    computed: {
        imageUrl() {
            return this.product.image;
        }
    }
}
const wishlistViewItem = {
    emits: ['remove'],
    template: `<li class="item default-item">
                <a v-bind:href="product.url" class="item-image" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></a>
                <a v-bind:href="product.url" class="product-name">{{product.title}}</a>
                <div class="item-details">
                    <div class="add-to-links">
                        <a v-bind:href="product.url" class="product-button">View {{product.type}}</a>
                        <span title="Remove Item" class="link-wishlist added" @click="$emit('remove',product)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </div>
                </div>
              </li>
              `,
    props: {
        product: Object
    },
    computed: {
        imageUrl() {
            return this.product.image;
        }
    }
}
const wishlistLink = {
    template: `<span class="link-wishlist" 
                    :class="{added: isActive()}"
                    @click.stop.prevent="wishlistAction()"><span v-if="isProductPage"></span></span>`,
    props: {
        id: Number,
        isProductPage: Boolean,
        type: String,
        url: String,
        image: String,
        title: String,
    },
    data() {
        return {
            item: {
                'id': this.id,
                'type': this.type,
                'url': this.url,
                'image': this.image,
                'title': this.title
            }
        }
    },
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        }
    },
    methods: {
        wishlistAction() {
            if(this.isActive()) {
                this.$store.dispatch('wishlist/remove', {
                    item: this.item
                })
            } else {
                this.$store.dispatch('wishlist/add', {
                    item: this.item
                })
            }
        },
        isActive() {
            const itemFound = this.items.filter(row => (
                (row.id === this.item.id || row.id === parseInt(this.item.id)) &&
                row.type === this.item.type
            ));
            return itemFound.length > 0;
        }
    }
}
const loadWishlist = {
    template: `
    <div class="empty-wishlist" v-if="itemsCount === 0">
        <p class="sub-title">There's nothing in your wishlist!</p>
        <p><a class="button" href="/collections/murals">Shop Murals</a></p>
        <p class="hr-separator"><span>or</span></p>
        <p class="sub-title">Load a Saved Wishlist</p>
        <p>Access a saved wishlist by entering your email below.</p>
        <form id="popup-load-form2" @submit.prevent="load" :class="{'limitless-loading': loading}">
            <div class="row">
                <div class="col-sm-12">
                    <input v-model="email" type="email" class="input-text required-entry validate-email" :class="{'validation-failed': localErrors.length}" placeholder="Your Email Address*" id="popup-load-email2" />
                    <div class="validation-advice" id="advice-required-entry-popup-load-email2" v-if="localErrors.length">This is a required field.</div>
                </div>
            </div>
            <div class="actions">
                <button type="submit" class="button popup-button wishlist-popup-button" title="Load Wishlist" name="load"><span><span>Load Wishlist</span></span></button>
            </div>
        </form>
    </div>`,
    data() {
        return {
            localErrors: [],
            loading: false,
            email: ''
        }
    },
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        load() {
            this.localErrors = [];
            if (!this.email) {
                this.localErrors.push('Email required.');
                return false;
            }
            this.loading = true;
            const url = this.remoteWishlistUrl + 'api/load';
            let form = new FormData();
            form.append('isAjax',true);
            form.append('email',this.email);
            axios.post(url, form)
                .then((response) => {
                    if(response.data) {
                        if(response.data.error) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.errorMessage(response.data.error)
                            })
                            this.$store.dispatch('modal/open')
                        } else if(response.data.message) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.successMessage(response.data.message)
                            })
                            this.$store.dispatch('modal/open')
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() => {
                this.loading = false;
            });
        }
    }
}
const wishlistViewApp = Vue.createApp({
    components: {
        'loadwishlist': loadWishlist,
        'wishlistviewitem': wishlistViewItem
    },
    data() {
        return {
            hash: null,
            loading: false
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        if(params.has('restore') === true) {
            this.hash = params.get('restore');
            this.restore();
        }
    },
    mounted () {
        setTimeout(() => {
            const event = new Event('wishlist:autosave');
            window.dispatchEvent(event);
        },500);
    },
    computed: {
        items() {
            return store.getters['wishlist/items'];
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        restore() {
            if(this.hash && this.hash !== '') {
                this.loading = true;
                const url = this.remoteWishlistUrl + 'api/restore';
                let form = new FormData();
                form.append('isAjax',true);
                form.append('id',this.hash);
                axios.post(url, form)
                    .then((response) => {
                        if(response.data) {
                            if(response.data.error) {
                                this.$store.dispatch('modal/set', {
                                    'modalClass': 'modal-message',
                                    'modalBody': this.errorMessage(response.data.error)
                                })
                                this.$store.dispatch('modal/open')
                            } else if(response.data.loaded_wishlist) {
                                try {
                                    store.dispatch('wishlist/load', {
                                        items: JSON.parse(response.data.loaded_wishlist)
                                    })
                                } catch (e) {

                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    }).finally(() => {
                    this.loading = false;
                });
            }
        },
        save() {
            try {
                const event = new Event('wishlist:save');
                window.dispatchEvent(event);
            } catch(e) {
                console.error(e);
            }
        },
        share() {
            try {
                const event = new Event('wishlist:share');
                window.dispatchEvent(event);
            } catch(e) {
                console.error(e);
            }
        },
        clear() {
            if(confirm("Do you really want to remove all items from your wishlist?")) {
                store.dispatch('wishlist/clear')
            }
        },
        remove(item) {
            if(item) {
                store.dispatch('wishlist/remove', {
                    item: item
                })
            }
        }
    }
})
wishlistViewApp.use(AdobeClientPlugin).use(store);
wishlistViewApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router')
wishlistViewApp.config.unwrapInjectedRef = true
if(document.getElementById('my-wishlist')) {
    wishlistViewApp.mount('#my-wishlist');
}

const saveWishlistComponent = {
    data() {
        return {
            email: localStorage.getItem('limitlesswalls_wishlist_email'),
            isError: false,
            loading: false,
        }
    },
    template: `<div class="modal-mask">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container limitless-save-popup" :class="{'limitless-loading': loading}" @click.stop="">
          <div class="modal-header">Save your Wishlist</div>
          <div class="modal-body">
            <p>Come back to your wishlist later, access it from another device, or share it with others easily. No account needed, simply enter your email address and your list will be saved.</p>
            <form method="post" action="" @submit.prevent="save">
                <div>
                  <input type="email" class="input-text required-entry validate-email" v-model="email" @click="isError = false" placeholder="Your Email Address*">
                  <div class="validation-advice" v-if="isError">This is a required field.</div>
                </div>
                <div class="actions">
                  <button type="submit" class="popup-button wishlist-popup-button"><span><span>Save Wishlist</span></span></button>
                </div>
            </form>
          </div>
          <div class="modal-footer">
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>`,
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        close() {
            this.$emit('closeModal');
        },
        save() {
            this.isError = false;
            if(!this.email) {
                this.isError = true;
                return false;
            }
            this.loading = true;
            localStorage.setItem('limitlesswalls_wishlist_email', this.email);
            appCookies.remove('limitlesswalls_wishlist_saved');
            appCookies.set('limitlesswalls_wishlist_saved',999, { expires: 1 });
            const url = this.remoteWishlistUrl + 'api/save';
            let form = new FormData();
            form.append('isAjax',true);
            form.append('wishlist',JSON.stringify(this.items));
            form.append('email',this.email);
            axios.post(url, form)
                .then((response) => {
                    if(response.data) {
                        this.close();
                        if(response.data.error) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.errorMessage(response.data.error)
                            })
                            this.$store.dispatch('modal/open')
                        } else if(response.data.message) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.successMessage(response.data.message)
                            })
                            this.$store.dispatch('modal/open')
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                    this.close();
                });
        }
    }
}
const shareWishlistComponent = {
    data() {
        return {
            to: '',
            from: '',
            name: '',
            message: '',
            isError: {
                'to': false,
                'from': false,
                'name': false,
            },
            loading: false,
        }
    },
    template: `<div class="modal-mask">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container limitless-save-popup limitless-share-popup" :class="{'limitless-loading': loading}" @click.stop="">
          <div class="modal-header">Share your Wishlist</div>
          <div class="modal-body">
            <form method="post" action="" @submit.prevent="share">
              <div class="row">
                <div class="col-sm-6">
                  <input type="text" class="input-text required-entry" placeholder="Your Name*" v-model="name" @click="isError.name = false">
                  <div class="validation-advice" v-if="isError.name">This is a required field.</div>
                </div>
                <div class="col-sm-6">
                  <input type="email" class="input-text required-entry validate-email" placeholder="Your Email Address*" v-model="from" @click="isError.from = false">
                  <div class="validation-advice" v-if="isError.from">This is a required field.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <input type="email" class="input-text required-entry validate-email" placeholder="Recipient's Email Address*" v-model="to" @click="isError.to = false">
                  <div class="validation-advice" v-if="isError.to">This is a required field.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                    <textarea class="input-text" cols="60" rows="2" placeholder="Message" v-model="message"></textarea>
                </div>
              </div>
              <div class="actions">
                <button type="submit" class="popup-button wishlist-popup-button" title="Share Wishlist"><span><span>Share Wishlist</span></span></button>
              </div>
            </form>
          </div>
          <div class="modal-footer">
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>`,
    computed: {
        items() {
            return this.$store.getters['wishlist/items'];
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        share() {
            if(!this.to) {
                this.isError['to'] = true;
            }
            if(!this.from) {
                this.isError['from'] = true;
            }
            if(!this.name) {
                this.isError['name'] = true;
            }
            for(const key in this.isError) {
                if(this.isError[key] === true) {
                    return false;
                }
            }
            this.loading = true;
            const url = this.remoteWishlistUrl + 'api/share';
            let form = new FormData();
            form.append('isAjax',true);
            form.append('wishlist',JSON.stringify(this.items));
            form.append('to',this.to);
            form.append('from',this.from);
            form.append('name',this.name);
            form.append('message',this.message);
            axios.post(url, form)
                .then((response) => {
                    if(response.data) {
                        this.close();
                        if(response.data.error) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.errorMessage(response.data.error)
                            })
                            this.$store.dispatch('modal/open')
                        } else if(response.data.message) {
                            this.$store.dispatch('modal/set', {
                                'modalClass': 'modal-message',
                                'modalBody': this.successMessage(response.data.message)
                            })
                            this.$store.dispatch('modal/open')
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() => {
                this.loading = false;
                this.close();
            });
        },
        close() {
            this.$emit('closeModal');
        },
    }
}
const wishlistApp = Vue.createApp({
    components: {
        'wishlistitem': wishlistItem,
        'savewishlist': saveWishlistComponent,
        'sharewishlist': shareWishlistComponent,
        'wishlistlink': wishlistLink
    },
    data() {
        return {
            open: false,
            email: '',
            showSaveModal: false,
            showShareModal: false,
            sliderOptions: {
                'dots':false,
                'arrows': true,
                'slidesToShow': 5,
                'infinite': false,
                'swipeToSlide': true,
                'responsive': [
                    {
                        'breakpoint': 992,
                        'settings': {
                            'slidesToShow': 3
                        }
                    },
                ]
            }
        }
    },
    mounted () {
        window.addEventListener('wishlist:save', (event) => {
            this.save()
        });
        window.addEventListener('wishlist:autosave', (event) => {
            this.autoSave()
        });
        window.addEventListener('wishlist:share', (share) => {
            this.share()
        });
    },
    computed: {
        items() {
            return store.getters['wishlist/items'];
        },
        hasItems() {
            return this.items.length === 0;
        },
        itemsCount() {
            return this.items.length;
        }
    },
    methods: {
        clear() {
            if(confirm("Do you really want to remove all items from your wishlist?")) {
                store.dispatch('wishlist/clear')
            }
        },
        autoSave() {
            if(this.itemsCount > 0) {
                let saved = appCookies.get('limitlesswalls_wishlist_saved');
                saved = saved ? parseInt(saved) : 0;
                appCookies.remove('limitlesswalls_wishlist_saved');
                saved++;
                appCookies.set('limitlesswalls_wishlist_saved',saved, { expires: 1 });
                if(saved <= 2) {
                    this.open = true;
                    this.save();
                }
            }
        },
        save() {
            store.dispatch('modal/close')
            this.showSaveModal = true;
        },
        share() {
            store.dispatch('modal/close')
            this.showShareModal = true;
        },
        updateItem(item, action) {
            if(action === 'add') {
                this.addItem(item);
            } else if(action === 'remove') {
                this.removeItem(item);
            }
        },
        addItem(item) {
            if(item) {
                store.dispatch('wishlist/add', {
                    item: item
                })
            }
        },
        removeItem(item) {
            if(item) {
                store.dispatch('wishlist/remove', {
                    item: item
                })
            }
        },
        remove(item, action) {
            this.updateItem(item, action);
        },
        toggleWishlist() {
            this.open = !this.open;
            if(this.open) {
                this.autoSave();
            }
        },
        closeModal() {
            this.showSaveModal = false;
            this.showShareModal = false;
        },
    },
    template: `<div class="wishlist-container"
        :class="{ empty: hasItems, closed: !open }">
        <div class="block block-wishlist">
            <div class="block-title" @click="toggleWishlist">Wishlist ({{itemsCount}})<span class="wishlist-icon"><span>{{itemsCount}}</span></span></div>
            <div class="block-content">
                <div class="actions">
                    <div>
                        <a href="/collections/wishlist"><i class="fa fa-heart" aria-hidden="true"></i><span>View Wishlist</span></a>
                    </div>
                    <div>
                        <span class="wishlist-button" @click="save" :class="{disabled: itemsCount == 0 }"><i class="fa fa-floppy-o" aria-hidden="true"></i><span>Save</span></span>
                        <span class="wishlist-button" @click="share" :class="{disabled: itemsCount == 0 }"><i class="fa fa-envelope" aria-hidden="true"></i><span>Share</span></span>
                    </div>
                </div>
                <div class="mini-products-list light--scrollbar" id="wishlist-items-carousel">
                    <wishlistitem
                      v-for="item in items" 
                      :key="item.id"
                      :product="item"
                      @remove="remove"
                    ></wishlistitem>
                    <p class="empty" v-if="items.length == 0"><span>There's nothing in your wishlist! </span><a href="/collections/murals">Shop Murals</a> or <span class="wishlist-action" data-action="load">Load a Saved Wishlist</span></p>
                </div>
            </div>
        </div>
    </div>
    <transition name="modal">
      <savewishlist v-if="showSaveModal" @close-modal="closeModal"></savewishlist>
    </transition>
    <transition name="modal">
      <sharewishlist v-if="showShareModal" @close-modal="closeModal"></sharewishlist>
    </transition>`,
})
wishlistApp.use(AdobeClientPlugin).use(store);
wishlistApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router')
wishlistApp.config.unwrapInjectedRef = true
wishlistApp.mount('#wishlist-container');
